var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 13.2417V5.25835C1.66669 4.15002 2.30835 3.88335 3.09169 4.66668L5.25002 6.82502C5.57502 7.15002 6.10835 7.15002 6.42502 6.82502L9.40835 3.83335C9.73335 3.50835 10.2667 3.50835 10.5834 3.83335L13.575 6.82502C13.9 7.15002 14.4334 7.15002 14.75 6.82502L16.9084 4.66668C17.6917 3.88335 18.3334 4.15002 18.3334 5.25835V13.25C18.3334 15.75 16.6667 17.4167 14.1667 17.4167H5.83335C3.53335 17.4083 1.66669 15.5417 1.66669 13.2417Z",
    stroke: "#EE7200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownOrange);
export default __webpack_public_path__ + "static/media/crown-orange.39174243b60955a8d4094a67b14c726f.svg";
export { ForwardRef as ReactComponent };